




import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import MypageBookmarkList from '../../components/Membership/Mypage/MypageBookmarkList.vue'

@Component({
  components: { MypageBookmarkList }
})
export default class Mypagebookmark extends Vue {
  // MypageBookmarkListのダミーページ
  // コンポーネント化した部品をページに生成しないと、非ログイン時にcreatedイベントが実施されるため

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }
}
